var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/accordion.tsx";
import classNames from 'classnames';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Text } from 'soapbox/components/ui';
import DropdownMenu from 'soapbox/containers/dropdown_menu_container';
const messages = defineMessages({
  collapse: {
    "id": "accordion.collapse",
    "defaultMessage": "Collapse"
  },
  expand: {
    "id": "accordion.expand",
    "defaultMessage": "Expand"
  }
});
const Accordion = ({
  headline,
  children,
  menu,
  expanded = false,
  onToggle = () => {}
}) => {
  const intl = useIntl();
  const handleToggle = e => {
    onToggle(!expanded);
    e.preventDefault();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('accordion', {
      'accordion--expanded': expanded
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 5
    }
  }, menu && /*#__PURE__*/React.createElement("div", {
    className: "accordion__menu",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    items: menu,
    src: require('@tabler/icons/dots-vertical.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "accordion__title",
    onClick: handleToggle,
    title: intl.formatMessage(expanded ? messages.collapse : messages.expand),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, headline)), /*#__PURE__*/React.createElement("div", {
    className: "accordion__content",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }, children)));
};
export default Accordion;